import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {ANCHOR_BOTTOM, ANCHOR_RIGHT} from "@khan/guide-core";

/**
 * An anchor element for use by the notification popover components.
 */
const NotificationMessageAnchorSpan = (): React.ReactElement => (
    <span className={css(styles.anchor)} />
);

const styles = StyleSheet.create({
    anchor: {
        // We position the anchor in relation to the guide
        // sidebar anchor so that the popup displays in the
        // same location as the guide chat UI.
        position: "fixed",
        bottom: ANCHOR_BOTTOM + 62, // 142
        insetInlineEnd: ANCHOR_RIGHT + 155, // 175
        flexDirection: "row",
        justifyContent: "flex-end",
    },
});

export {NotificationMessageAnchorSpan};
